import { castRouteIds } from 'plugins/router/routes/castRouteIds'
import {
	noteCreate,
	noteEdit,
	notes,
	noteView,
} from 'plugins/router/routes/notes'
import { hideTicket } from 'plugins/router/routes/global'
import type { RouteRecordRaw } from 'vue-router'

const dashboard: RouteRecordRaw = {
	path: '/dashboard',
	alias: '/',
	redirect: { name: 'dashboard' },
	children: [
		{
			...notes,
			path: '',
			name: 'dashboard',
		},
		{
			path: 'tasks/:taskId',
			component: () => import('@/components/modules/Tasks/View.vue'),
			name: 'dashboardTask',
			meta: {
				hidden: hideTicket,
			},
			props: castRouteIds,
		},
		{
			path: 'cis',
			component: () => import('@/components/modules/Cis/View.vue'),
			name: 'dashboardCis',
			props: (route) => {
				return {
					cisId: parseInt(route.query.cisId as string),
				}
			},
		},
	],
	component: () => import('components/modules/Dashboard/Dashboard.vue'),
	meta: {
		title: 'Start',
		icon: '$dashboard',
		name: 'dashboard',
		auth: true,
		nav: true,
		ordering: 0,
	},
}

export { dashboard }
